var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningHexagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.17296 12.3C1.06578 12.1144 1.06578 11.8856 1.17296 11.7L6.32655 2.77372C6.43373 2.58808 6.63181 2.47372 6.84617 2.47372H17.1533C17.3677 2.47372 17.5658 2.58808 17.673 2.77372L22.8266 11.7C22.9337 11.8856 22.9337 12.1144 22.8266 12.3L17.673 21.2263C17.5658 21.4119 17.3677 21.5263 17.1533 21.5263H6.84617C6.63181 21.5263 6.43373 21.4119 6.32655 21.2263L1.17296 12.3Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8L12 12",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.01L12.01 15.9989",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningHexagon);
export default __webpack_public_path__ + "static/media/warning-hexagon.2df0546d.svg";
export { ForwardRef as ReactComponent };